import React from "react";
import { RadarEmptyGlyph } from "./symbols";

// =====================================================================
// Club Radar V2 — empty-state block (frames 1c desktop / 1f mobile).
// Copy arrives via props (title/body) from the surface builders — the
// kit bakes in no strings (sibling-kit i18n pattern). The S2 radar
// illustration renders 72×72 desktop / 64×64 mobile (same viewBox).
// =====================================================================

export const RadarEmptyBlock = ({ mobile = false, title, body, maxWidth, padding, style, children }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      maxWidth: maxWidth || (mobile ? 290 : 440),
      padding: padding || (mobile ? 20 : 24),
      margin: "0 auto",
      ...style,
    }}
  >
    <RadarEmptyGlyph size={mobile ? 64 : 72} />
    <div
      style={{
        marginTop: mobile ? 14 : 16,
        fontSize: mobile ? 15 : 16,
        fontWeight: 800,
        color: "#111827",
      }}
    >
      {title}
    </div>
    {body ? (
      <div
        style={{
          marginTop: 6,
          fontSize: mobile ? 12.5 : 13,
          color: "#6B7280",
          lineHeight: 1.55,
        }}
      >
        {body}
      </div>
    ) : null}
    {children}
  </div>
);
